import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import textContent from "@/components/textContent/textContent.vue";
import CircleRingChart from "@/components/circleRingChart/circleRingChart.vue";
import ResetDone from "@/components/resetDone/resetDone.vue";
import { routerIncludeTimes } from "@/utils/routerStackUtil";
import { getLang } from "@/api/utils/apiHelper";

var Personality =
/*#__PURE__*/
function (_Vue) {
  _inherits(Personality, _Vue);

  function Personality() {
    _classCallCheck(this, Personality);

    return _possibleConstructorReturn(this, _getPrototypeOf(Personality).apply(this, arguments));
  }

  _createClass(Personality, [{
    key: "done",
    value: function done() {
      var backNum = routerIncludeTimes("personalFutrue");
      this.routerGoBack(-backNum);
    }
  }, {
    key: "calcSwiperHeihgt",
    value: function calcSwiperHeihgt() {
      console.log("click");
    }
  }, {
    key: "reset",
    value: function reset() {
      this.personalFuture();
    }
  }, {
    key: "isShowComponents",
    get: function get() {
      return getLang() === "en";
    }
  }]);

  return Personality;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], Personality.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PERSONAL_FUTRUE)], Personality.prototype, "personalFuture", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], Personality.prototype, "nowData", void 0);

tslib_1.__decorate([Emit("calcSwiperHeihgt")], Personality.prototype, "calcSwiperHeihgt", null);

Personality = tslib_1.__decorate([Component({
  components: {
    textContent: textContent,
    CircleRingChart: CircleRingChart,
    ResetDone: ResetDone
  }
})], Personality);
export default Personality;